import { useContext, useEffect, useMemo } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";
import { YearOfBirthFilterButton } from "./YearOfBirthFilterParts/YearOfBirthFilterButton";

const YearOfBirthFilter = () => {
	const {
		dictionaryWords,
		sportsCamps,
		yearOfActivities,

		yearOfBirthCounter,
		setYearOfBirthCounter,

		yearOfBirth,
		setYearOfBirth,
		yearOfBirthButtonActive,
		setYearOfBirthButtonActive,
	} = useContext(SportsCampsContext);

	useEffect(() => {
		if (sportsCamps.counters) {
			const yearOfBirthCounters = [];
			sportsCamps.counters.forEach((Type) => {
				if (Type.Type === "yearOfBirth") {
					const object = {};
					object["YearOfBirth"] = Type.YearOfBirth;
					object["Count"] = Type.Count;
					yearOfBirthCounters.push(object);
				}
			});
			setYearOfBirthCounter(yearOfBirthCounters);
		}
	}, [JSON.stringify(sportsCamps.counters)]);

	const yearOfBirthFilterHandler = (event) => {
		if (yearOfBirth === "") {
			setYearOfBirth(event.target.id);
			setYearOfBirthButtonActive(true);
		} else if (yearOfBirth !== event.target.id) {
			setYearOfBirth(event.target.id);
			setYearOfBirthButtonActive(true);
		} else if (yearOfBirth === event.target.id) {
			setYearOfBirth("");
			setYearOfBirthButtonActive(false);
		}
	};

	const yearOfBirthButtons = useMemo(() => {
		if(yearOfBirthCounter && yearOfBirthCounter.length > 0) {
			return yearOfBirthCounter.map((object) => (
				<YearOfBirthFilterButton
					key={object.YearOfBirth}
					yearOfBirth={yearOfBirth}
					active={yearOfBirthButtonActive}
					object={object}
					yearOfActivities={yearOfActivities}
					handleClick={yearOfBirthFilterHandler}
					dictionaryWords={dictionaryWords} />
			))
		}
	}, [JSON.stringify(yearOfBirthCounter), yearOfBirthButtonActive, yearOfBirthFilterHandler, dictionaryWords]);

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.yearOfBirth}</h3>
			{sportsCamps.counters && yearOfBirthButtons}
		</div>
	);
};

export default YearOfBirthFilter;
